/**
 * Responsibility: Define shared scene-action processing status text and helpers.
 * Scope: Shared UI helper only; no dispatcher ownership or component rendering.
 */
export const PROCESS_LINES = [
  'WEAVING FATE...',
  'READING THE THREADS...',
  'ETCHING CONSEQUENCES...',
  'BENDING THE SCENE...',
  'SUMMONING THE NEXT BEAT...',
]

export const DEFAULT_PROCESS_LINE = PROCESS_LINES[0]

export function nextProcessLine(index = 0) {
  return PROCESS_LINES[(Number(index) + 1) % PROCESS_LINES.length]
}
